import {
  Alert,
  BULK_EDIT_UPDATE_EMPTY_WARNING,
  Card,
  Checkbox,
  Grid,
  pn,
  Stack,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Select } from "components";
import { DeveloperBulkUpdate, DeveloperBulkUpdateResource, DeveloperBulkUpdateSchema } from "generated/openApi";

export const DeveloperUpdateSchema = (props: {
  updateSchema: DeveloperBulkUpdateSchema;
  setUpdateSchema: (value: DeveloperBulkUpdateSchema) => void;
  resource: DeveloperBulkUpdateResource;
  validationErrors: ValidationErrors | string[];
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties =
    props.resource.properties?.find((x) => x.propertyName === pn<DeveloperBulkUpdate>("updateSchema"))?.children || [];

  const genderField = () => {
    const propertyName = pn<DeveloperBulkUpdateSchema>("genderId");
    const property = properties.find((x) => x.propertyName === propertyName);
    const isUpdating = props.updateSchema.updateGenderId;

    return (
      <Stack direction="row" alignItems="center" spacing="sm">
        <Checkbox
          checked={isUpdating}
          onChange={(e) => props.setUpdateSchema({ ...props.updateSchema, updateGenderId: e.target.checked })}
        />

        <Select
          modelProperty={property}
          required={isUpdating}
          errors={props.validationErrors[propertyName]}
          value={props.resource.genders?.find((x) => x.id === props.updateSchema.genderId)}
          options={props.resource.genders}
          getOptionLabel={(option) => option.name}
          onChange={(e, value) => props.setUpdateSchema({ ...props.updateSchema, genderId: value?.id })}
          disabled={!isUpdating}
        />
      </Stack>
    );
  };

  const typeField = () => {
    const propertyName = pn<DeveloperBulkUpdateSchema>("typeId");
    const property = properties.find((x) => x.propertyName === propertyName);
    const isUpdating = props.updateSchema.updateTypeId;

    return (
      <Stack direction="row" alignItems="center" spacing="sm">
        <Checkbox
          checked={isUpdating}
          onChange={(e) => props.setUpdateSchema({ ...props.updateSchema, updateTypeId: e.target.checked })}
        />

        <Select
          modelProperty={property}
          errors={props.validationErrors[propertyName]}
          value={props.resource.developerTypes?.find((x) => x.id === props.updateSchema.typeId)}
          options={props.resource.developerTypes}
          getOptionLabel={(option) => option.name}
          onChange={(e, value) => props.setUpdateSchema({ ...props.updateSchema, typeId: value?.id })}
          disabled={!isUpdating}
        />
      </Stack>
    );
  };

  return (
    <Card header="Updating Fields">
      <Stack spacing="md">
        <Alert severity="warning" variant="standard">
          {BULK_EDIT_UPDATE_EMPTY_WARNING}
        </Alert>

        <Grid ref={breakpointsRef} container spacing="sm">
          <Grid item xs={smallFieldBreakpoints}>
            {genderField()}
          </Grid>

          <Grid item xs={smallFieldBreakpoints}>
            {typeField()}
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
